module.exports = __webpack_public_path__ + "pigmentace_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_3_after.jpg
// module id = 973
// module chunks = 0